import type { Table } from '@tanstack/react-table';
import type { File } from '../../../../types/file.types';
import { flexRender } from '@tanstack/react-table';

interface FileListHeaderProps {
  table: Table<File>;
}

export const FileListHeader = ({ table }: FileListHeaderProps) => {
  return (
    <thead className="sticky top-0 z-[51] bg-slate-50 dark:bg-[#232323]">
      {table.getHeaderGroups().map((headerGroup) => (
        <tr key={headerGroup.id}>
          {headerGroup.headers.map((header) => (
            <th
              key={header.id}
              style={{
                width: header.getSize(),
              }}
              className={`h-10 font-light table-cell-${header.column.id}`}
            >
              {header.isPlaceholder ? null : (
                <div
                  className={
                    header.column.getCanSort()
                      ? 'cursor-pointer'
                      : 'pointer-events-none'
                  }
                  onClick={
                    header.column.getCanSort()
                      ? header.column.getToggleSortingHandler()
                      : undefined
                  }
                >
                  {flexRender(
                    header.column.columnDef.header,
                    header.getContext()
                  )}
                </div>
              )}
            </th>
          ))}
        </tr>
      ))}
    </thead>
  );
};
